import { render } from "./AutocompleteMaps.vue?vue&type=template&id=04e171c7"
import script from "./AutocompleteMaps.vue?vue&type=script&lang=js"
export * from "./AutocompleteMaps.vue?vue&type=script&lang=js"
script.render = render

export default script